import React from 'react';
import { useApp } from '../context/AppContext';

export default function CategoryFilter({ tabs, active, onChange }) {
  const { t } = useApp();
  return (
    <div className="sticky top-[68px] z-40 bg-white/95 backdrop-blur border-b border-neutral-200">
      <div className="max-w-[1280px] mx-auto px-5 py-3 flex gap-2 overflow-x-auto no-scrollbar">
        {tabs.map((c) => {
          const isActive = active === c.key;
          return (
            <button
              key={c.key}
              data-testid={`tab-${c.key}`}
              onClick={() => onChange(c.key)}
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border ${
                isActive
                  ? 'bg-[#4b5e34] text-white border-[#4b5e34] shadow-sm'
                  : 'bg-white text-neutral-700 border-neutral-200 hover:border-[#4b5e34] hover:text-[#4b5e34]'
              }`}
            >
              {t(c.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
